import { KeyValuePipe, NgClass } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MiImageContainerComponent } from 'app/modules/shared/ui-sharable/mi-image-container/mi-image-container.component';
import { ButtonModule } from 'primeng/button';
import { ChartModule } from 'primeng/chart';
import { DropdownModule } from 'primeng/dropdown';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { AppIcons } from '../../../../shared/app.icons';
import { CommonBindingDataService } from '../../../../shared/services/common-binding-data.service';
import { EntityService } from '../../../../shared/services/entity.service';
import { TrialAttributeValues, TrialAttributeLabels, TrialOrganizedAttribute, TrialDetails } from '../../../models/trials';
import { ConfigService } from '../../../../shared/services/config.service';

interface SponsorDetails {
  sponsor_status?: Record<string, string>;
  sponsor_code?: string;
  sponsor_name?: string;
  email?: string;
  spn_addr_name?: string;
  spn_addr_line_1?: string;
  contact_number?: string;
  [key: string]: unknown;
}

interface DropdownItem {
  label: string;
  value: string;
  [key: string]: unknown;
}

interface ChartData {
  labels: string[];
  datasets: Array<{
    label: string;
    data: number[];
    [key: string]: unknown;
  }>;
}

interface ChartOptions {
  responsive: boolean;
  maintainAspectRatio: boolean;
  [key: string]: unknown;
}

interface TabData {
  label: string;
  icon: string;
  [key: string]: unknown;
}

interface DetailsData {
  [key: string]: unknown;
}

interface RowData {
  [key: string]: unknown;
}

@Component({
  selector: 'app-sponsors',
  standalone: true,
  imports: [ButtonModule, TranslateModule, DropdownModule, ChartModule, OverlayPanelModule, FormsModule,
    MiImageContainerComponent, NgClass, KeyValuePipe
  ],
  templateUrl: './sponsors.component.html',
  styleUrl: './sponsors.component.scss'
})
export class SponsorsComponent implements OnInit, OnChanges {
  miIcons = AppIcons;
  iconPos: 'left' | 'right' = 'right';
  @Input() attributeValues: TrialAttributeValues;
  @Input() attributeLabels: TrialAttributeLabels;
  @Input() vehicleAttributeData: TrialOrganizedAttribute;
  @Input() vehicleEntityId: string;
  @Input() vehicleRowData: RowData;
  @Input() trialDetails: TrialDetails;
  @Input() isDeleted: boolean = false;
  @Input() isUnassigned: boolean = false;
  @Output() onToggleOverLay: EventEmitter<boolean> = new EventEmitter();

  dropDownItems: DropdownItem[] = [];
  selectedItem: DropdownItem[] = [];
  data: ChartData;
  options: ChartOptions;
  tab: TabData;
  details: DetailsData;
  center: google.maps.LatLngLiteral = {
    lat: 24,
    lng: 12,
  };
  zoom = 4;
  map: google.maps.Map;
  bulkRowCount = 1;
  barcodeImage: string;
  visiblePrintLabel: boolean = false;
  rowData: RowData;
  isLoading: boolean = false;
  selectedEventId: string;
  eventLat: number;
  eventLng: number;
  marker: google.maps.Marker;
  regionGeofences: string[] = [];
  zoneIds: string[] = [];
  fields: unknown;
  regionGeofence: string;
  matchedZoneDisplayName: string = '';
  openLogo: string = "../../../../../../assets/images/mi-theme/light/nav/pdf_icon.png"
  sponserDetails: SponsorDetails;
  isEditAllowed: boolean = false;
  constructor(public vehicleService: EntityService,
    public cs: CommonBindingDataService, private router: Router,
    private cd: ChangeDetectorRef,
    private configService: ConfigService
  ) { }

  ngOnChanges() {
  }

  ngOnInit() {
    this.isEditAllowed = !this.configService.isSiteUser();
    if (this.attributeValues?.sponsor_entity_id) {
      this.sponserDetails = this.attributeValues.sponsor_details as SponsorDetails;
    }
  }

  scrollToTop() {

    const tabviewPanels = document.querySelector('.p-tabview-panels');
    if (tabviewPanels) {
      tabviewPanels.scrollTop = 0;
    }
  }

  redirectToEdit() {
    this.router.navigate(['/app/sponsors/add-sponsor'], { queryParams: { 'id': this.attributeValues?.sponsor_entity_id } });
  }

  formatAddress() {
    const parts = [
      this.sponserDetails.spn_addr_name,
      this.sponserDetails.spn_addr_line_1,
      this.sponserDetails.spn_addr_line_2,
      this.sponserDetails.spn_street,
      this.sponserDetails.spn_city,
      this.sponserDetails.spn_state,
      this.sponserDetails.spn_zip

    ].filter(Boolean);
    return parts.join(', ');
  }
}


